import React from 'react';
import styled from 'styled-components';
import { IconBase } from '../Base';
const Wrapper = styled.div `
  position: relative;
`;
const Line = styled.path `
  stroke-dasharray: 9px;
  stroke-dashoffset: var(--offset);
`;
const Second = styled(IconBase) `
  --offset: 23px;

  position: absolute;
  left: 0;
  top: 0;
`;
export const IconSearch = (props) => {
    return (React.createElement(Wrapper, null,
        React.createElement(IconBase, { ...props },
            React.createElement("g", { fill: "none", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round", style: { stroke: 'var(--icon-color)' } },
                React.createElement("path", { d: "M9 15C12.3137 15 15 12.3137 15 9C15 5.68629 12.3137 3 9 3C5.68629 3 3 5.68629 3 9C3 12.3137 5.68629 15 9 15Z" }))),
        React.createElement(Second, { ...props },
            React.createElement("g", { fill: "none", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round", style: { stroke: 'var(--icon-color)' } },
                React.createElement(Line, { d: "M16.5 16.5L10 10" })))));
};
//# sourceMappingURL=Search.js.map